import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styles from './storie-successo.module.css';
import ArrowRightSvg from '@svg/arrow-right.svg';

function StoryCarouselItem({
  imageUrl,
  mainTitle,
  title,
  description,
  id,
  hasPdf,
  index,
  externalUrl
}) {
  return (
    <>
      <div
        className={cn(styles['div-image'], `snf-bg-repeat-no-repeat`)}
        style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : undefined }}
      >
        <div className={`py-5 ${styles.imgHeader}`}>
          <p className="text-uppercase snf-font-14 snf-font-md-20 m-0 snf-color-white text-center">
            {mainTitle}
          </p>
        </div>
      </div>
      <div className={styles.divStory}>
        <div className={cn(styles.storyHeader, 'snf-bg-color-prussian-blue', 'storyHeader')}>
          <div className={styles.divTitle}>
            <h3 className="snf-color-white text-left text-uppercase snf-font-20 snf-font-w6">
              {title}
            </h3>
          </div>

          <p className="snf-color-white">{description}</p>
          <div className={styles.divButton}>
            {externalUrl ? (
              <a href={externalUrl} target="_blank" rel="noreferrer">
                <button
                  type="button"
                  className="btn rounded-0 snf-bg-color-denim text-white px-3 snf-font-16 text-uppercase snf-font-w6"
                >
                  <FormattedMessage
                    defaultMessage="Mostra di più"
                    description="Storie di successo / Home - Maggior informazioni"
                  />
                  <span className="ml-3">
                    <ArrowRightSvg />
                  </span>
                </button>
              </a>
            ) : (
              <Link
                to={
                  hasPdf
                    ? { pathname: '/azienda', hash: 'Certificazioni' }
                    : `/${index}/detail/${id}`
                }
              >
                <button
                  type="button"
                  className="btn rounded-0 snf-bg-color-denim text-white px-3 snf-font-16 text-uppercase snf-font-w6"
                >
                  <FormattedMessage
                    defaultMessage="Mostra di più"
                    description="Storie di successo / Home - Maggior informazioni"
                  />
                  <span className="ml-3">
                    <ArrowRightSvg />
                  </span>
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

StoryCarouselItem.displayName = 'StoryCarouselItem - Util';
export { StoryCarouselItem };
